import React from "react"

import { Control } from "react-hook-form"

import RatingSelect from "./RatingSelect"
import SectionHeader from "./SectionHeader"

interface LoadCheckSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  calculateResult: () => void
}

const loadCheckOptions = [
  { value: "Loaded", label: "Loaded - All items accounted for and properly loaded" },
  { value: "Partially Loaded", label: "Partially Loaded - Some issues, but mostly complete" },
  { value: "Not Loaded", label: "Not Loaded - Driver began route without a prepared load" },
]

const LoadCheckSection: React.FC<LoadCheckSectionProps> = ({ control, calculateResult }) => {
  return (
    <div className="space-y-4">
      <SectionHeader title="Load Check - Parcel Preparedness" />

      <RatingSelect
        control={control}
        name="loadCheck"
        label="Whether the van was correctly and fully loaded before departure"
        options={loadCheckOptions}
        calculateResult={calculateResult}
      />
    </div>
  )
}

export default LoadCheckSection
